"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingUserPermissionsCard = exports.PendingUserEmailSlot = void 0;
var react_1 = __importDefault(require("react"));
var BasePermissionsCard_1 = require("../BasePermissionsCard");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PendingUserPermissionsCard = function (_a) {
    var email = _a.email, permissionsDropdown = _a.permissionsDropdown;
    return (react_1.default.createElement("div", { className: "pending-user-permissions-card" },
        react_1.default.createElement(BasePermissionsCard_1.BasePermissionsCard, { avatarSlot: react_1.default.createElement(kaleidoscope_1.Avatar, null), nameSlot: email, descriptionSlot: react_1.default.createElement(PendingUserEmailSlot, null), permissionsSlot: permissionsDropdown })));
};
exports.PendingUserPermissionsCard = PendingUserPermissionsCard;
var PendingUserEmailSlot = function () { return react_1.default.createElement("div", { className: "pending-user-permissions-card__pending-text" }, "PENDING"); };
exports.PendingUserEmailSlot = PendingUserEmailSlot;
